// Convert text like `(a)` into `<sup>a</sup>` markup
const markupSuperscripts = text =>
  text
    .replace(
      /( ?\(([a-z0-9]{1,2})\)(?![A-Z]))/g,
      (_, __, char) => `<sup>${char}</sup>`
    )
    .replace(/^( ?\(([a-z0-9]{1,2})\) ?)/g)

export default markupSuperscripts
